import { styled } from '@mui/material';

export type HtmlTypographyProps = {
  bodyHtml: string;
  additionalStyles?: object;
  className?: string;
};

/**
 * Renders HTML content as styled typography from [MicroLibraryCoreUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryCoreUI)
 *
 * @param {HtmlTypographyProps} props - The props for the HtmlTypography component.
 * @param {string} props.bodyHtml - The HTML content to display.
 * @param {object} [props.additionalStyles] - Additional styles to apply to the content.
 */

export const HtmlTypography = ({
  bodyHtml,
  additionalStyles,
  className,
}: HtmlTypographyProps) => {
  const innerHtml = { __html: bodyHtml ?? '' };

  const FormattedHtml = styled('div')(({ theme }) => ({
    wordBreak: 'break-word',
    ...theme.typography.body1,
    '& p': {
      ...theme.typography.body1,
    },
    '& h1': {
      ...theme.typography.h1,
    },
    '& h2': {
      ...theme.typography.h2,
    },
    '& h3': {
      ...theme.typography.h3,
    },
    '& h4': {
      ...theme.typography.h4,
    },
    '& h5': {
      ...theme.typography.h5,
    },
    '& h6': {
      ...theme.typography.h6,
    },
    '& a': {
      ...theme.typography.body1,
      textDecoration: 'underline',
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightBold,
    },
    '& li > p': {
      marginTop: 0,
      marginBottom: 0,
    },
    ...additionalStyles,
  }));

  return (
    <FormattedHtml dangerouslySetInnerHTML={innerHtml} className={className} />
  );
};
